// extracted by mini-css-extract-plugin
module.exports = {"resetFormWrapper":"InitializeResetPasswordPage_resetFormWrapper__1KaPa"};